// Primitive 9 — Badge / Chip. Sert notamment aux statuts de devis.
// La correspondance statut → ton est ici, à un seul endroit, alignée
// sur la contrainte CHECK de la base.

import { LIBELLES_STATUT } from '@shared/schemas.js';

const STATUS_TONES = {
  draft: 'neutral',
  sent: 'info',
  pending: 'warn',
  won: 'ok',
  production: 'ok',
  lost: 'danger',
  expired: 'neutral',
};

// Les libellés viennent de `shared/` : un seul vocabulaire (6 octobre 2026).
const STATUS_LABELS = LIBELLES_STATUT;

export function Badge({ tone = 'neutral', children }) {
  return <span className={`badge badge--${tone}`}>{children}</span>;
}

/**
 * ── « ENREGISTRÉ » N'EST PAS UN STATUT — 21 août 2026 ──
 *
 * Charles : « quand j'appuie sur enregistrer, il faudrait une étiquette
 * *enregistré* à la place de *brouillon*, comme ça je vois ceux que j'ai
 * déjà travaillés avant de les envoyer. »
 *
 * Un devis créé par dépôt d'un PDF et un devis relu, corrigé, enregistré
 * disaient tous les deux « Brouillon ».
 *
 * La distinction se lit sur `enregistre_at`, pas sur `status` : le
 * statut décrit où en est l'AFFAIRE (envoyée, gagnée, perdue) et pilote
 * l'envoi, la relance et la péremption. « Enregistré » décrit un GESTE
 * de l'utilisateur, et un geste se date. Une sixième valeur d'énumération
 * aurait obligé à décider, dans six endroits, si elle se comporte comme
 * un brouillon.
 *
 * Le ton change aussi : `info` et non `neutral`. Une pastille qui garde
 * la couleur du brouillon ne se repère pas dans une liste de trente
 * lignes — c'est précisément le tri que Charles demande.
 */
export function StatusBadge({ status, enregistreAt = null }) {
  if (status === 'draft' && enregistreAt) return <Badge tone="info">Enregistré</Badge>;
  return <Badge tone={STATUS_TONES[status] ?? 'neutral'}>{STATUS_LABELS[status] ?? status}</Badge>;
}

export default Badge;
